<template>
  <div class="discount-code">
    <label for="discount-code-input">{{ __('Discount code') }}</label>

    <div class="input-group">
      <input type="text"
             class="form-control"
             id="discount-code-input"
             v-model="value"
             :disabled="requestPending"
             :class="{'is-invalid': validated && !valid}"
             @keyup.enter="submit">

      <div class="input-group-append">
        <button @click="submit" class="btn btn-secondary" type="button" :disabled="requestPending || value.length === 0">
          <div class="spinner-border text-light" v-if="requestPending"></div>
          <div v-else>{{ __('Apply') }}</div>
        </button>
      </div>
    </div>

    <div class="text-danger font-weight-normal text-xs mt-2" v-if="validated && !valid">{{ __('Invalid discount code') }}</div>
    <div class="text-success font-weight-normal text-xs mt-2" v-if="validated && valid">{{ __('Valid discount code') }}</div>
  </div>
</template>

<script>
import Api from "@/Services/Api";

export default {
  name: "DiscountCode",

  data() {
    return {
      requestPending: false,
      value: '',
      valid: false,
      validated: false,
    };
  },

  watch: {
    value(code) {
      this.value = code.toUpperCase();
    },
  },

  methods: {
    submit() {
      this.requestPending = true;

      Api.discountCode(this.value)
        .then(resp => {
          if (resp.status === 200) {
            this.valid = true;

            this.$store.state.discount.code  = this.value;
            this.$store.state.discount.type  = resp.data.type;
            this.$store.state.discount.value = resp.data.value;
            this.$store.state.discount.products = resp.data.products;
          } else {
            this.valid = false;

            this.$store.state.discount.code  = null;
            this.$store.state.discount.type  = null;
            this.$store.state.discount.value = null;
            this.$store.state.discount.products = [];
          }
          this.validated = true;
        })
        .finally(() => this.requestPending = false)
    },
  },
};
</script>
